__webpack_require__.p = "/dialog-header-text-size/referrals-hub/";